import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Field, reduxForm} from 'redux-form';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import {Content, FieldsWrap, FieldWrap, Form, FormDescription, KioskFormDescription, FormLoader, Header, KioskHeader, styles, SubmitBtnWrap} from '../LoginForm/styles';
import FormCloseIcon from '../LoginForm/FormCloseIcon';
import {NEGATIVE_COLOR} from '../../config/colors';
import {reduxFormValidators} from '../../helpers/validators';
import "./KioslOrderForm.css"

const validate = values => {
  const errors = {};
  Object.keys(values).forEach(field => {
    if (field.length.length === 0) {
      errors[field] = 'Required';
    }
  });

  return errors;
};
// TODO:
// - form should have scroll
class KioskOrderForm extends Component {

    renderTextInput = ({input, label, meta: {touched, error}, ...custom}) => {
        const {isPaymentKiosk} = this.props;
        const requiredAsterisk = custom.required ? <span style={{color: 'rgb(244, 67, 54)'}}> *</span> : null;
        const fieldClass = 'label ' + ((input.name.length > 45 && (custom.type  !== 'number')) ? 'long-label': '');
        const inputFieldStyle = this.props.isPaymentKiosk ? styles.paymentKioskInputField : styles.inputField; 
        const inputStyle = this.props.isPaymentKiosk ? styles.paymentKioskInputStyle : {}; 
        const inputfloatingLabelStyleFieldStyle = this.props.isPaymentKiosk ? styles.paymentKioskfloatingLabelStyle :  styles.floatingLabelStyle; 
        const floatingLabelTextStyle = isPaymentKiosk ? {height: '100px', fontSize: '45px', color: NEGATIVE_COLOR} : {color: NEGATIVE_COLOR};
        const errorStyle = isPaymentKiosk ? {...styles.submitBtnErrorStyle, bottom: '-7px', fontSize: '18px'} : {...styles.submitBtnErrorStyle, bottom: '-7px', fontSize: '11px'}
        return <TextField
          className={fieldClass}
            floatingLabelText={<span style={floatingLabelTextStyle}>{label}{requiredAsterisk}</span>}
            floatingLabelStyle={inputfloatingLabelStyleFieldStyle}
            style={inputFieldStyle}
            inputStyle={inputStyle}
            errorStyle={errorStyle}
            errorText={(touched && error ? error : '')}
            {...input}
            {...custom}
        />
    };

    renderDropdownInput = ({input, label, meta: {touched, error}, ...custom}) => {
        const labelText = custom.required ? <span>{label}<span style={{color: 'rgb(244, 67, 54)'}}> *</span></span> : label;
        const fieldClass = 'label ' + ((input.name.length > 45 && (custom.type  !== 'number')) ? 'long-label': '');
        const {isPaymentKiosk} = this.props;
        const errorStyle = isPaymentKiosk ? {...styles.submitBtnErrorStyle, bottom: '-7px', fontSize: '18px'} : {...styles.submitBtnErrorStyle, bottom: '-7px', fontSize: '11px'}

        return <SelectField
            className={fieldClass}
            floatingLabelText={labelText}
            fullWidth
            {...input}
            onChange={(event, i, val) => input.onChange(val)}
            {...custom}
            errorStyle={errorStyle}
        />
    };

  renderShortTextField = (field, i) => {
    const validators = [reduxFormValidators.maxLength(64)];
    const {isPaymentKiosk} = this.props;
    const errorStyle = isPaymentKiosk ? {...styles.submitBtnErrorStyle, bottom: '-7px', fontSize: '18px'} : {...styles.submitBtnErrorStyle, bottom: '-7px', fontSize: '11px'}

    if (field.isRequired) {
      validators.push(reduxFormValidators.requiredValue);
    }

    return (
      <FieldWrap
        key={i}
        width={isPaymentKiosk ? "100%" : "calc(50% - 30px)"}
        compact
      >
        <Field
          type="text"
          name={`${field.label}_(${i+100})`}
          validate={validators}
          label={field.label}
          required={field.isRequired}
          component={this.renderTextInput}
          errorStyle={errorStyle}
        />
      </FieldWrap>
    );
  };

  renderNumberField = (field, i) => {
    const validators = [reduxFormValidators.maxLength(64)];

    if (field.isRequired) validators.push(reduxFormValidators.requiredValue);

    return (
      <FieldWrap
        key={i}
        compact
      >
        <Field
          name={`${field.label}_(${i+200})`}
          type="number"
          validate={validators}
          label={field.label}
          required={field.isRequired}
          component={this.renderTextInput}
        />
      </FieldWrap>
    );
  }

  renderDropdownField = (field, i) => {
    const validators = [];

    if (field.isRequired) validators.push(reduxFormValidators.requiredValue);

    // do not render dropdown with empty options
    if (!field.dropdownOptions || (field.dropdownOptions && !field.dropdownOptions.length)) {
      return null;
    }

    return (
      <FieldWrap
        key={i}
      >
        <Field
          name={`${field.label}_(${i+300})`}
          type="text"
          validate={validators}
          label={field.label}
          required={field.isRequired}
          component={this.renderDropdownInput}
         >
          {field.dropdownOptions && field.dropdownOptions.map((option) => (
            <MenuItem key={option} value={option} primaryText={option}/>
          ))}
        </Field>
      </FieldWrap>
    );
  };

  renderFields = () => {
    const {fields} = this.props;

    return fields.map((field, i) => {
      switch (field.noteType) {
      case 'shortAnswer':
        return this.renderShortTextField(field, i);
      case 'number':
        return this.renderNumberField(field, i);
      case 'dropdown':
        return this.renderDropdownField(field, i);
      default:
        console.warn('Incorrect field type');

        return this.renderShortTextField(field.label, i);
      }
    });
  };

  submit = () => {
    const {handleSubmit, valid} = this.props;
    if (valid) {
      handleSubmit();
    } 
  }

  render() {
    const {
      isPaymentKiosk,
      onClose,
      handleSubmit,
      isUploadInProgress} = this.props;
    const submitBtnLabel = isPaymentKiosk ? styles.paymentKioskSubmitBtnLabel : styles.submitBtnLabel;
    const submitBtnStyle = isPaymentKiosk ? styles.paymentKioskSubmitBtn : styles.submitBtn;
    const secondaryColor = `#${this.props.secondaryColor}`;
    const closeIconStyleName = isPaymentKiosk ? 'closeIconLarge' : 'closeIcon';
    return (
      <Form
        className="kiosk-order-form"
        name="kioskOrderForm"
      >
        <FormLoader loading={isUploadInProgress}>
          <CircularProgress size={60} thickness={5}/>
        </FormLoader>

        <FormCloseIcon styleName={closeIconStyleName} onClick={onClose}/>
        <Content>
          {!isPaymentKiosk &&
            <Header>
              <span>ORDER INFORMATION</span>
            </Header>
          }
          {isPaymentKiosk &&
            <KioskHeader>
              <span>ORDER INFORMATION</span>
            </KioskHeader>
          }
          {!isPaymentKiosk &&
            <FormDescription>
              Please enter the following information so we can match your order during checkout.
            </FormDescription>
          }
          {isPaymentKiosk &&
            <KioskFormDescription>
              Please enter the following information so we can match your order during checkout.
            </KioskFormDescription>
          }
          <FieldsWrap compact>
            {this.renderFields()}
          </FieldsWrap>

          <SubmitBtnWrap compact>
            <RaisedButton
              onClick={handleSubmit}
              type="submit"
              backgroundColor={secondaryColor}
              labelStyle={submitBtnLabel}
              overlayStyle={styles.submitBtnOverlayStyle}
              buttonStyle={submitBtnStyle}
              fullWidth
              label="Complete"
            />
          </SubmitBtnWrap>
        </Content>
      </Form>
    );
  }
}

KioskOrderForm.propTypes = {
  pristine: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  isPaymentKiosk: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  fields: PropTypes.arrayOf(PropTypes.shape({
    noteType: PropTypes.string.isRequired
  })).isRequired
};

export default reduxForm({
  validate,
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
  form: 'kioskOrderForm',
})(KioskOrderForm);



// WEBPACK FOOTER //
// ./src/components/KioskOrderModal/KioskOrderForm.jsx